<template>
  <div class="trade-container">
    <div>
      <div class="trade-wrap">
        <div class="trade-info-wrap top">
          <div class="card">
            <div class="user-assets" flex fic fje>
              <div style="line-height: 18px">{{ $t("ieo.trade.balance") }}</div>
              <div class="number ml10" style="line-height: 18px">
                {{ wallet.available | formatNumber(hideFixedValueWhenKRW) }}
              </div>
              <div class="assets-code ml5" style="line-height: 18px">
                {{ ciCode }}
              </div>
              <div v-if="isShowDeposit" class="withdrawal ml10">
                <div @click="goToDeposit(ciCode)">
                  <!-- {{ ciCode }}  -->
                  {{ $t("ieo.trade.deposit") }}
                </div>
              </div>
            </div>
            <!-- 인풋박스 -->
            <div class="trade-row buy">
              <p>{{ $t("ieo.trade.amount") }}</p>
              <div flex fic>
                <dd>
                  <IEO-input
                    v-model="orderAmount"
                    :disabled="DealStatus !== 'ing'"
                    :decimal="hideFixedValueWhenKRW"
                    class="input-payment"
                  />
                </dd>
                <div class="buyCoin">{{ ciCode }}</div>
              </div>
            </div>
            <!-- 퍼센트박스 -->
            <div class="volume-slider-wrap">
              <button @click="setPercent(10)" class="amount-set">10%</button>
              <button @click="setPercent(25)" class="amount-set">25%</button>
              <button @click="setPercent(50)" class="amount-set">50%</button>
              <button @click="setPercent(100)" class="amount-set">최대</button>
            </div>
            <!-- 구매할 코인 박스 -->
            <div class="getCoin">
              <div flex>
                <p>{{ totalAmount | formatNumber(6) }}</p>
                <p class="getCoinName">{{ ieoInfo.ieCode }}</p>
              </div>
            </div>
            <div class="bonusText">{{ $t("ieo.trade.bonusText") }}</div>
            <!-- 구매수량 계산박스 -->
            <div class="trade-info-wrap userOrderToken">
              <dl class="trade-row" v-if="dealInfo">
                <dt>{{ $t("ieo.trade.minAmount") }}</dt>
                <dd>
                  <div>
                    {{ minTradeAmount | formatNumber(hideFixedValueWhenKRW) }}
                  </div>
                  <span>{{ ciCode }}</span>
                </dd>
              </dl>
              <dl class="trade-row trade-ratio" v-if="dealInfo">
                <dt>{{ $t("ieo.trade.maxAmount") }}</dt>
                <dd>
                  {{ dealInfo.userMaxCnt | formatNumber }}
                  <span>{{ ieoInfo.ieCode }}</span>
                </dd>
              </dl>
              <dl class="trade-row">
                <dt>{{ $t("ieo.trade.totalPurchaseAmount") }}</dt>
                <dd>
                  {{
                    ieoInfo.userBuyCnt == undefined
                      ? 0
                      : ieoInfo.userBuyCnt | formatNumber(8)
                  }}
                  <span>{{ ieoInfo.ieCode }}</span>
                </dd>
              </dl>
            </div>
          </div>
          <!-- 체크박스 -->
          <div class="agreement-checkbox">
            <div class="checkbox-wrap" flex>
              <div class="pt6">
                <el-checkbox v-model="isPurchaseAgree" class="IEOAgreement">
                </el-checkbox>
              </div>
              <div class="text-wrap" flex fjb>
                <p class="desc">{{ $t("ieo.trade.agree") }}</p>
                <div
                  @click="terms = !terms"
                  :class="{ active: terms }"
                  class="more-button IEOTerms"
                >
                  {{ $t("ieo.trade.viewTerm") }}
                </div>
              </div>
              <div class="hidden" v-if="terms">
                <!-- <p v-html="$t('ieo.trade.agreeContents')"></p> -->
                <p>(i) 토큰 구매에 대한 유의 사항</p>
                <p class="hidden-text">
                  - 본 토큰스왑은 프로젝트팀의 정책에 의거하여 진행되며, 구매
                  확정 전 토큰 구매에 대한 모든 내용을 확인 후 구매해주시기
                  바랍니다.<br />
                  - 구매 시 제공되는 보너스 자산은 프로젝트 팀 정책에 따라 지급
                  시점이 달라질 수 있으며, 별도의 Lock이 설정될 수 있습니다.<br />
                  - 프로젝트의 토큰 분배 이후 상장 전까지 입출금 서비스가 제한될
                  수 있습니다.
                </p>
                <p class="hidden-text">
                  (ii) 투자 위험성과 투자자 보호
                </p>
                <p class="hidden-text">
                  - 가상자산은 법정 화폐가 아니기 때문에 원금 손실의 가능성이
                  있으며, 예금자보호법을 적용받지 않습니다.<br />
                  - 단순 변심으로 인한 구매 취소나 환불은 불가하오니 반드시
                  유념하시기 바랍니다.<br />
                  - 프로젝트의 사정으로 토큰 분배가 진행되지 않는 경우 구매
                  결제에 사용된 가상자산은 환불이 가능하며, 해당 시점에 발생하는
                  시세 차익 또는 손실은 투자자 본인에게 귀속됩니다.
                </p>
              </div>
            </div>
            <div class="checkbox-wrap mt10" flex>
              <div class="pt6">
                <el-checkbox v-model="isQualificationAgree" class="">
                </el-checkbox>
              </div>
              <div class="text-wrap" flex fjb>
                <p class="desc">{{ $t("ieo.trade.citizen") }}</p>

                <div
                  @click="contract = !contract"
                  :class="{ active: contract }"
                  class="more-button IEOTerms"
                >
                  {{ $t("ieo.trade.viewMore") }}
                </div>
              </div>
              <div class="hidden" v-if="contract">
                <p
                  class="hidden-text"
                  v-html="$t('ieo.trade.citizenContents[0]')"
                ></p>
                <p
                  class="hidden-text"
                  v-html="$t('ieo.trade.citizenContents[1]')"
                ></p>
                <p
                  class="hidden-text"
                  v-html="$t('ieo.trade.citizenContents[2]')"
                ></p>
              </div>
            </div>
          </div>
          <!-- 구매하기 버튼 -->
          <div class="button">
            <!-- 진행중 -->
            <div class="prepare">
              <!-- <div v-if="!isDealEnd" class="prepare"> -->
              <!-- 로그인 여부에 따른 버튼 분기 -->
              <div v-if="isLogin">
                <div class="allibaba__box" v-if="DealStatus == 'ing'">
                  <allibaba
                    @send-response-data-event="getResponseData"
                    ref="alibaba"
                    :swapvisible="false"
                  ></allibaba>
                  <div v-if="recaptchaErr" class="allibaba__box-error">
                    {{ $t("login.error.captcha") }}
                  </div>
                </div>
                <el-button
                  @click="order"
                  ref="purchaseBtn"
                  class="IEObutton"
                  :disabled="
                    !isQualificationAgree ||
                      !isPurchaseAgree ||
                      orderAmount === '' ||
                      orderAmount === 0 ||
                      orderAmount === '0' ||
                      ali_response === null
                  "
                >
                  {{ $t("ieo.trade.purchase") }}
                </el-button>
              </div>
              <div class="button" v-else>
                <router-link :to="LoginRouter">
                  <el-button
                    class="IEObutton"
                    @click="goLogin()"
                    ref="orderBtn"
                    >{{ $t("login.login") }}</el-button
                  >
                </router-link>
              </div>
              <div class="amount amount-wrap"></div>
              <div class="graph sellAmount">
                <span class="text">{{
                  DealStatus == "ing"
                    ? $t("ieo.trade.amountSold")
                    : $t("ieo.trade.amountSold")
                }}</span>
                <span class="number">{{
                  DealStatus == "ing" ? sellAmount : ""
                }}</span>
                <el-progress
                  :text-inside="false"
                  :stroke-width="20"
                  :percentage="Number(percentProgress)"
                ></el-progress>
                <div class="percent">{{ percentProgress }}%</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 토탈 카드박스 -->
        <div class="card">
          <div class="trade-info-wrap summary">
            <dl class="trade-row">
              <dt>{{ $t("ieo.trade.estimatedValue") }}</dt>
              <dd>
                <div v-if="dealInfo.ciCode === 'KRW'">
                  {{ orderAmount | formatNumber }}
                </div>
                <div v-else>
                  {{ (orderAmount * recentMarketPrice) | formatNumber }}
                </div>
                <!-- <div v-else>{{ ((tradeAmount * 1) / dealInfo.chgRate) | formatNumber(8) }}</div> -->
                <span>KRW</span>
              </dd>
            </dl>
            <dl class="trade-row trade-ratio">
              <dt>{{ $t("ieo.trade.price") }}</dt>
              <dd>
                {{
                  dealInfo.chgRate === 0
                    ? 0
                    : (1 / dealInfo.chgRate) | formatNumber(8)
                }}
                <span>{{ ciCode }}</span>
              </dd>
            </dl>
            <dl class="trade-row">
              <dt>{{ $t("ieo.trade.purchaseAmount") }}</dt>
              <dd>
                {{ tradeAmount | formatNumber(6) }}
                <span>{{ ieoInfo.ieCode }}</span>
              </dd>
            </dl>
            <dl class="trade-row">
              <dt>{{ $t("ieo.trade.bonus") }}({{ ieoInfo.bonusRate }}%)</dt>
              <dd>
                {{ bonusAmount | formatNumber(6) }}
                <span>{{ ieoInfo.ieCode }}</span>
              </dd>
            </dl>
            <dl class="trade-row totalCount">
              <dt class="addBonus">
                {{ $t("ieo.trade.amountIncludingBonus") }}
              </dt>
              <dd>
                {{ totalAmount | formatNumber(6) }}
                <span>{{ ieoInfo.ieCode }}</span>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 거래불가 안내 팝업 -->
    <Popup v-if="isPopupShow" :data="popUpData" :close="closePopup" />
    <!-- 거래불가 안내 팝업 -->
    <!-- 거래불가 안내 팝업 -->
    <Popup v-if="isTermsShow" :data="termsData" :close="closeTermsModal" />
    <!-- 거래불가 안내 팝업 -->

    <!-- 구매 완료 모달 -->
    <el-dialog
      title="알림"
      :visible.sync="isShowOrderConfirm"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p>
          {{ totalAmount.toFixed(6) }}개의 {{ ieoInfo.ieCode }}를 구매합니다.
        </p>
        <p>{{ $t("ieo.trade.messageBuying") }}</p>
        <p>{{ $t("notice.content.AreYouSureOrder") }}</p>
      </div>
      <span slot="footer" class="dialog-footer two">
        <button @click="isShowOrderConfirm = false">
          {{ $t("confirm.cancel") }}
        </button>
        <button @click="confirmOrder">{{ $t("ieo.trade.purchase") }}</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import Moment from "moment";
import Decimal from "decimal.js";
import IEOInput from "./ieoInput.vue";
import { mapGetters, mapActions } from "vuex";
import allibaba from "@/components/login/allibaba";
import Popup from "@/components/common/Popup.vue";
import { authIDModal } from "@/common/authIdModal.js";
import GlobalEvent from "@/common/Event";

export default {
  name: "IEOTrade",
  props: {
    tkCode: {
      type: [Number, String],
      required: true,
    },
    dealInfo: {
      type: Object,
      required: true,
    },
    ieoInfo: {
      type: Object,
      required: true,
    },
    whiteListModal: {
      type: Function,
      required: true,
    },
    isWhiteList: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    IEOInput,
    allibaba,
    Popup,
  },
  data() {
    return {
      orderAmount: 0,
      forceResetFlag: true,
      agreeWithAssignment: false,
      isPurchaseAgree: false,
      isQualificationAgree: false,
      terms: false,
      contract: false,
      recentMarketPrice: 0,
      remainDateStr: "",
      ali_response: null,
      recaptchaErr: false,
      // 거래불가 회원 안내 메시지
      popUpData: {
        description: this.$t("trade.OrderRestriction.description"),
        confirm: this.$t("trade.OrderRestriction.confirm"),
      },
      termsData: {
        description: this.$t("trade.OrderRestriction.description"),
        confirm: this.$t("trade.OrderRestriction.confirm"),
      },
      // 거래불가 회원 모달 여부
      isPopupShow: false,
      isTermsShow: false,
      isShowOrderConfirm: false,
    };
  },
  created() {
    this.$;

    this.recentMarketPrice = this.toKRW(this.dealInfo.ciCode).price;

    const zendesk = document.getElementById("launcher");
    if (zendesk) {
      if (this.$route.path === "/") {
        document.getElementById("launcher").style.visibility = "visible";
      } else {
        document.getElementById("launcher").style.visibility = "hidden";
      }
    }
    if (this.wallet.available == undefined) {
      return (this.wallet.available = 0);
    }
  },
  computed: {
    ...mapGetters(["sliceVolume", "isLogin", "userInfo", "toKRW"]),
    LoginRouter() {
      return { name: "Login", params: { fullPath: this.$route.fullPath } };
    },
    ciCode() {
      this.orderAmount = NaN;
      return _.get(this, ["dealInfo", "ciCode"], "");
    },
    // isAvail() {
    //   if (
    //     new Decimal((this.ieoInfo.ieCnt / this.ieoInfo.totalCount) * 100).gte(
    //       99
    //     )
    //   ) {
    //     return false;
    //   }
    //   return true;

    //   this.inPeriodNow(
    //     this.ieoInfo.startDatetime,
    //     this.ieoInfo.endDatetime
    //   );
    // },
    marketId() {
      switch (this.ciCode) {
        case "BTC":
          return 54;
        case "KRW":
          return 0;
        case "ETH":
          return 55;
        case "USDT":
          return 6042;
      }
    },
    ciCoinInfo() {
      return this.$store.state.Market.coin[this.ciCode];
    },
    wallet() {
      return this.$store.getters.wallet[this.dealInfo.cidx] || {};
    },
    sellAmount() {
      const sell = Decimal(this.ieoInfo.totalCount)
        .sub(this.amountLeft)
        .toFixed(2, Decimal.ROUND_DOWN)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sell;
    },
    availCnt() {
      return Decimal(this.ieoInfo.totalCount).sub(this.ieoInfo.ieCnt);
    },
    minTradeAmount() {
      return this.dealInfo.minCnt;
    },
    maxTradeAmount() {
      return _.min([+this.IEOToCoin(this.availCnt), this.wallet.available]);
    },
    tradeAmount() {
      if (isNaN(this.orderAmount)) return this.coinToIEO(0);
      return this.coinToIEO(this.orderAmount);
    },
    bonusAmount() {
      return Decimal(this.tradeAmount)
        .mul(this.ieoInfo.bonusRate)
        .div(100);
    },
    totalAmount() {
      return Decimal(this.tradeAmount).add(this.bonusAmount);
    },
    hideFixedValueWhenKRW() {
      return this.ciCode === "KRW" ? 0 : 8;
    },
    DealStatus() {
      if (Moment(this.ieoInfo.startDatetime) > Moment()) {
        return "soon";
      }
      if (this.ieoInfo.completeYn === "Y") {
        return "end";
      }
      if (
        new Decimal((this.ieoInfo.ieCnt / this.ieoInfo.totalCount) * 100).gte(
          99
        )
      ) {
        return "end";
      }
      if (Moment(this.ieoInfo.endDatetime) < Moment()) {
        return "end";
      }
      return "ing";
    },
    percentProgress() {
      const progress = Decimal(this.ieoInfo.ieCnt)
        .div(this.ieoInfo.totalCount)
        .mul(100)
        .toFixed(2, Decimal.ROUND_DOWN);
      if (
        new Decimal((this.ieoInfo.ieCnt / this.ieoInfo.totalCount) * 100).gte(
          99
        )
      ) {
        return 100;
      } else if (this.ieoInfo.completeYn === "Y") {
        return 100;
      } else {
        return progress;
      }
    },
    amountLeft() {
      const left = Decimal(this.ieoInfo.totalCount)
        .sub(this.ieoInfo.ieCnt)
        .toFixed(2, Decimal.ROUND_DOWN);
      return left;
    },
    // wlf 사유 코드 분기
    wlfcontents() {
      if (this.isLogin) {
        if (this.userInfo.dueDiligenceInfo) {
          const code = this.userInfo.dueDiligenceInfo.wlfContents;
          switch (code) {
            case "01":
              return "금융위원회에서 고시하는 금융거래제한대상자";
            case "02":
              return "FATF 지정 위험국가 국적자 또는 거주자";
            case "03":
              return "FATF 지정 위험국가 국적자 또는 거주자";
            case "04":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
            case "05":
              return "UN에서 지정하는 제재대상자";
            case "06":
              return "외국의 정치적 주요 인물";
            case "07":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
            case "08":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
            case "09":
              return "";
            case "10":
              return "당사에서 자금세탁행위등의 위험을 우려하여 지정한 거래제한 국가";
            default:
              break;
          }
          return;
        }
      }
    },
    isShowDeposit() {
      const endEvent = Moment(this.ieoInfo.endDatetime) < Moment();
      if (this.isLogin && !endEvent) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["logOut"]),
    getResponseData(data) {
      if (data) {
        this.ali_response = data;
        this.recaptchaErr = false;
      }
    },
    closePopup() {
      this.isPopupShow = !this.isPopupShow;
    },
    closeTermsModal() {
      this.isTermsShow = false;
    },
    // 현재 선택된 화폐의 값을 IEO 진행중인 코인의 수로 변환
    coinToIEO(value) {
      return Decimal(value).mul(this.dealInfo.chgRate);
    },
    IEOToCoin(value) {
      return Decimal(value).div(this.dealInfo.chgRate);
    },
    order() {
      if (!authIDModal(this.userInfo)) {
        return;
      }

      // 거래불가 회원일경우
      if (!this.userInfo.configInfo.wowYn) {
        this.logOut().then(() => {
          this.$notify({
            title: this.$t("notice.title.attention"),
            message: this.$t("notice.content.logoutComplete"),
            type: "warning",
            customClass: "dexko-noti",
            position: "top-left",
          });
        });
        return;
      } else if (this.userInfo.configInfo.wowYn === "N") {
        this.popUpData = {
          description: this.$t("trade.OrderRestriction.description"),
          confirm: this.$t("trade.OrderRestriction.confirm"),
        };
        return (this.isPopupShow = true);
      }
      if (this.isWhiteList && this.userInfo.configInfo.wowWhitelistYn === "N") {
        return this.whiteListModal();
      }

      if (this.userInfo.mPhone == null) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messagePhone"),
          type: "info",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (this.orderAmount <= 0 || !parseInt(this.orderAmount)) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.placeholder"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (this.orderAmount > this.wallet.available) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("notice.content.checkOrderAmount"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (this.orderAmount < this.minTradeAmount) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messageMinCount"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (this.totalAmount.lt(this.totalAmount)) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messageQuantity"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (
        new Decimal(this.dealInfo.userMaxCnt).lessThan(
          new Decimal(this.ieoInfo.userBuyCnt).plus(this.tradeAmount.toFixed(8))
        )
      ) {
        console.log("111111");

        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messageMaxCount"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        // this.$forceUpdate();

        return false;
      }
      if (this.isPurchaseAgree == false) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messageCheck1"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      if (this.isQualificationAgree == false) {
        this.$notify({
          title: this.$t("notice.title.error"),
          message: this.$t("ieo.trade.messageCheck2"),
          type: "error",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }

      if (!this.ali_response) {
        return (this.recaptchaErr = true);
      }

      this.isShowOrderConfirm = true;
    },
    async confirmOrder() {
      this.isShowOrderConfirm = false;
      try {
        const { ali_token, ali_sig, ali_csessionid } = this.ali_response
          ? this.ali_response
          : { ali_token: null, ali_sig: null, ali_csessionid: null };
        const formData = {
          tkCode: this.tkCode,
          cidx: this.ciCoinInfo.id,
          coinCnt: this.orderAmount,
          ali_token,
          ali_sig,
          ali_csessionid,
        };

        const res = await this.$api.IEO.requestIEOSale(formData);
        // const wlfYn = this.userInfo.dueDiligenceInfo.wlfYn; // wlf 거절 여부
        // if (wlfYn && wlfYn == "Y") {
        //   GlobalEvent.$emit("wlfReject");
        //   return;
        // }
        this.$notify({
          title: this.$t("notice.title.attention"),
          message: "구매가 완료 되었습니다.",
          type: "info",
          customClass: "dexko-noti",
          position: "top-left",
        });
        this.$emit("trade");
        this.$store.dispatch("getUserWallet");
        this.$forceUpdate();
        return res;
      } catch (err) {
        if (err.response.status === 401) {
          console.log("ssssss");
          this.logOut().then(() => {
            this.$notify({
              title: this.$t("notice.title.attention"),
              message: this.$t("notice.content.logoutComplete"),
              type: "info",
              customClass: "dexko-noti",
              position: "top-left",
            });
          });
          return;
        }
        if (err === "cancel") {
          return err;
        }
        if (err.code === "4500") {
          this.$notify({
            title: this.$t("notice.title.error"),
            message: this.$t("ieo.trade.messageMaxCount"),
            type: "error",
            customClass: "dexko-noti",
            position: "top-left",
          });
        } else if (err.code == "6001" || err.code == "6002") {
          this.authIDModal(this.userInfo);
          return;
        } else {
          this.$notify({
            title: this.$t("notice.title.error"),
            message: _.get(err, ["msg"], err.msg),
            type: "error",
            customClass: "dexko-noti",
            position: "top-left",
          });
        }

        setTimeout(() => {
          location.reload();
        }, 2000);
      }
    },
    //퍼센트 버튼
    setPercent(val) {
      if (this.isLogin && this.DealStatus == "ing") {
        this.perc = _.clamp(_.ceil(val), 0, 100);
        const possibleAmount =
          this.dealInfo.userMaxCnt - this.ieoInfo.userBuyCnt;
        const mathAmount =
          Math.round(this.dealInfo.userMaxCnt) -
          Math.round(this.ieoInfo.userBuyCnt);
        if (this.ciCode === "KRW") {
          if (
            mathAmount * (1 / this.dealInfo.chgRate) >
            this.wallet.available
          ) {
            const userAmount = (this.wallet.available / 100) * this.perc;
            this.orderAmount = this.sliceVolume(userAmount, this.minTrade);
          } else {
            const volumeAmount =
              ((mathAmount * (1 / this.dealInfo.chgRate)) / 100) * this.perc;
            this.orderAmount = this.sliceVolume(volumeAmount, this.minTrade);
          }
        } else {
          if (
            possibleAmount * (1 / this.dealInfo.chgRate) >
            this.wallet.available
          ) {
            const userAmount = (this.wallet.available / 100) * this.perc;
            this.orderAmount = this.sliceVolume(userAmount, this.minTrade);
          } else {
            const volumeAmount =
              ((possibleAmount * (1 / this.dealInfo.chgRate)) / 100) *
              this.perc;
            this.orderAmount = this.sliceVolume(volumeAmount, this.minTrade);
          }
        }
      }

      // loginCheck() {
      //   if (!this.isLogin) {
      //     // GlobalEvent.$emit("loginException");
      //     this.$nextTick(() => {
      //       this.perc = 0;
      //     });
      //     return false;
      //   } else {
      //     return true;
      //   }
    },

    // inPeriodNow(startDate, endDate) {
    //   return Moment().isBetween(Moment(startDate), Moment(endDate));
    // },
    goToDeposit(ciCode) {
      this.$router.push(`/mypage/deposit/${ciCode}`);
    },
    moveToDatailContract() {
      window.open(this.zendeskUrl["ko"]["tokenSwapBanCountries"]);
    },
    moveToDatailTerms() {
      window.open(this.zendeskUrl["ko"]["tokenSwapTerms"]);
    },
  },

  filters: {
    showIntWhenKRW(val, ciCode) {
      return ciCode === "KRW" ? parseInt(val) : Decimal(val).toFixed(8);
    },
  },
  watch: {
    marketId() {
      this.$api.Trade.getLastTrade(this.marketId, {
        completed: "Y",
        count: 20,
        page: 1,
      }).then((_res) => {
        this.recentMarketPrice = _res.data.result[0].price;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  font-family: "spoqa Han Sans";
  p {
    margin-bottom: 0;
  }
}
.trade-container {
  font-family: "spoqa Han Sans";
  .trade-ratio {
    color: #0056b6;
    font-family: "nanumBold";
    font-style: normal;
    font-weight: bold;
  }
  .trade-wrap {
    .trade-info-wrap {
      margin-top: 20px;
      border-bottom: 0;
      .trade-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        dt,
        dd {
          line-height: 1.5;
          color: #000000;
          font-weight: 500;
          display: flex;
          align-items: center;
        }
        dd {
          text-align: right;
          justify-content: flex-end;
          input {
            max-width: 80%;
          }
        }
      }
      h3 {
        font-weight: bold;
      }
      .IEO-assignment {
        border: 1px solid #d1d5da;
        padding: 7px;
        margin-top: 12px;
        height: 180px;
        overflow-y: auto;
      }
      .withdrawal {
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 4px;
        a {
          p {
            /* font-size: 13px; */
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.46;
            letter-spacing: normal;
            text-align: right;
            color: #222222;
          }
        }
      }
      .user-assets {
        text-align: right;
      }
      &.top {
        margin-top: 10px;
      }
      &.summary {
        padding: 12px 17px;
        border: 1px solid #999;
      }
      .user-assets {
        margin: 4px 0 12px;
        text-align: right;
        span {
          /* font-size: 13px; */
          font-weight: 400;
          color: #333333;
          &.number {
            letter-spacing: 0.5px;
          }
          &.assets-code {
            color: #777;
          }
        }
      }
      .trade-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.buy {
          padding: 0 10px 0 15px;
          height: 50px;
          border: 1px solid #ccc;
          p {
            font-size: 14px;
          }
          span {
            /* font-size: 14px; */
            color: #666666;
          }
          .buyCoin {
            width: fit-content;
            padding-left: 8px;
            text-align: right;
            color: #666;
          }
        }
        dd {
          input {
            max-width: 80%;
          }
          span {
            margin-left: 4px;
            font-weight: bold;
            color: #333;
            word-break: keep-all;
          }
        }
        &.minTradeAmount {
          margin: 6px 0 15px 0;
          p {
            font-size: 13px;
            span {
              color: #777;
            }
          }
          .minOrderAmount {
            font-weight: 400;
          }
        }
        &.totalCount {
          margin-top: 1px;
          font-weight: bold;
          line-height: 1.38;
          letter-spacing: 0.43px;
          color: #222;
          .addBonus {
            color: #222;
            font-weight: bold;
            letter-spacing: normal;
          }
          dd {
            max-width: 65%;
            color: #222;
            font-weight: bold;
          }
        }
      }
      .volume-slider-wrap {
        display: flex;
        margin-top: 10px;
        .amount-set {
          display: block;
          width: 25%;
          height: 40px;
          margin-right: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          background: #fff;
          font-family: "spoqa Han Snas";
          letter-spacing: 0.5px;
          color: #333;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      .agreement-checkbox {
        margin: 20px 0;
        .checkbox-wrap {
          .text-wrap {
            align-items: center;
            width: calc(100% - 20px);
            padding-left: 10px;
            line-height: 20px;
            .desc {
              width: calc(100% - 78px);
            }
            .more-button {
              max-height: 32px;
              padding: 5px;
              border: 1px solid #ccc;
              border-radius: 4px;
            }
          }
        }
        span {
          margin-left: 5px;
          text-decoration: underline;
        }
        .hidden {
          padding: 10px;
          margin-top: 10px;
          border-radius: 4px;
          background: #f7f8fa;
        }
        .hidden-text {
          color: #333d48;
          margin-top: 10px;
          &:first-of-type {
            margin: 0;
          }
        }
        /* .IEOQualification.isActive + .hidden {
          height: 430px;
          overflow-y: scroll;
          margin: 7.5px 0;
          border-radius: 4px;
          transition: all 1s;
          background: #f7f8fa;
        } */
      }
      .button {
        .IEObutton {
          width: 100%;
          height: 50px;
          padding: 13px 0;
          background-color: #eb3246;
          border: 1px solid #eb3246;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          &.end {
            border-color: #ccc;
            background-color: #ccc;
          }
          &.eventOver {
            background-color: #ccc;
            border: 1px solid #ccc;
          }
          &.disabled {
            border-color: #afafaf;
            background-color: #afafaf;
          }
        }
        .trade-row.OpenBtn {
          margin-top: 20px;
          .endText {
            font-weight: bold;
            line-height: 1.29;
            letter-spacing: normal;
            color: #333333;
          }
          .endDate {
            font-weight: bold;
            line-height: 1.38;
            letter-spacing: 0.5px;
            color: #f41320;
            text-decoration: underline;
          }
          &.soldoutHidden {
            display: none;
          }
        }
        .amount {
          text-align: right;
          &.amount-wrap {
          }
          div {
            display: flex;
            justify-content: flex-end;
            font-weight: bold;
            line-height: 1.38;
            p {
              width: 105px;
              padding-left: 14px;
              /* font-size: 13px; */
              font-weight: 400;
              letter-spacing: 0.43px;
              &:first-child {
                font-weight: bold;
              }
            }
          }
        }
        .graph {
          span {
            /* font-size: 13px; */
            font-weight: bold;
            line-height: 1.46;
            letter-spacing: normal;
            text-align: center;
            color: #333333;
            &.number {
              font-weight: 400;
            }
          }
          .percent {
            margin-top: 7px;
            /* font-size: 13px; */
            font-weight: normal;
            line-height: 1.38;
            letter-spacing: normal;
            color: #f41320;
          }
          &.sellAmount {
            padding-top: 20px;
          }
        }
      }
      &.arrangement {
        margin-top: 15px;
        padding: 12px 17px 13px;
        border: 1px solid #999;
      }
      h3 {
        font-weight: bold;
      }
      .IEO-assignment {
        border: 1px solid #d1d5da;
        padding: 7px;
        margin-top: 12px;
        height: 180px;
        overflow-y: auto;
      }
      .getCoin {
        text-align: right;
        /* height: 37px; */
        margin-top: 10px;
        padding: 10px;
        border: 1px solid #333;
        div {
          justify-content: flex-end;
          p {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.5px;
          }
          .getCoinName {
            /* width: 48px; */
            padding-left: 8px;
            /* font-size: 14px; */
            font-weight: 400;
            letter-spacing: normal;
            color: #666666;
          }
        }
      }
      .bonusText {
        margin-top: 4px;
        text-align: right;
        color: #f41320;
      }
      .userOrderToken {
        margin-top: 10px;
      }
    }
  }
}
::v-deep .vs-con-input-label {
  width: 100px;
  margin-bottom: 0;
  input {
    text-align: right;
  }
}
::v-deep.el-checkbox {
  .el-checkbox__label {
    /* font-size: 12px; */
    font-weight: 400;
  }
}
.card {
  &:last-of-type {
    border: 0;
  }
}
.KYC-button {
  padding: 10px;
  /* font-size: 11px; */
  border: 1px solid #afafaf;
  border-radius: 2px;
  color: #333;
  background-color: #fff;
}
.text-type01 a {
  text-decoration: underline;
  color: #1a0dab;
}

.agreement-description p {
  word-break: keep-all;
}

.allibaba__box {
  padding-bottom: 20px;

  &-error {
    color: #f41320;
    padding-top: 5px;
  }
}
</style>
